import { render, staticRenderFns } from "./listOwner.vue?vue&type=template&id=24e02818&scoped=true"
import script from "./listOwner.vue?vue&type=script&lang=js"
export * from "./listOwner.vue?vue&type=script&lang=js"
import style0 from "./listOwner.vue?vue&type=style&index=0&id=24e02818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e02818",
  null
  
)

export default component.exports